import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initSentry } from "./services/sentry";

initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const unregisterDevelopmentServiceWorkers = async () => {
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  } catch (error) {
    console.warn("ManuCalc service worker cleanup failed:", error);
  }
};

const registerProductionServiceWorker = () => {
  window.addEventListener("load", () => {
    let refreshingForNewWorker = false;

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshingForNewWorker) return;
      refreshingForNewWorker = true;
      window.location.reload();
    });

    navigator.serviceWorker.register("/service-worker.js", { updateViaCache: "none" })
      .then((registration) => {
        registration.update?.().catch((error) => {
          console.warn("ManuCalc service worker update failed:", error);
        });
        if (registration.waiting && navigator.serviceWorker.controller) {
          window.dispatchEvent(new CustomEvent("manucalc:pwa-update-ready", { detail: { registration } }));
        }
        registration.addEventListener("updatefound", () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;

          installingWorker.addEventListener("statechange", () => {
            if (installingWorker.state === "installed" && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent("manucalc:pwa-update-ready", { detail: { registration } }));
            }
          });
        });
      })
      .catch((error) => {
        console.warn("ManuCalc service worker registration failed:", error);
      });
  });
};

if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV === "production") {
    registerProductionServiceWorker();
  } else {
    unregisterDevelopmentServiceWorkers();
  }
}
